import React from "react";

function Internet() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      fill="none"
      viewBox="0 0 44 44"
    >
      <g
        stroke="#13121A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.75"
        clipPath="url(#clip0_226_695)"
      >
        <path d="M5.5 22a16.5 16.5 0 1033 0 16.5 16.5 0 00-33 0zM6.6 16.5h30.8M6.6 27.5h30.8M21.083 5.5a31.166 31.166 0 000 33M22.917 5.5a31.167 31.167 0 010 33"></path>
      </g>
      <defs>
        <clipPath id="clip0_226_695">
          <path fill="#fff" d="M0 0H44V44H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Internet;
